<script>
import MethodButtonBase from './MethodButtonBase';
import IconMobileId from '../../assets/svg/mobile-id.svg';
export default {
  name: 'MobileIdButton',
  components: {
    MethodButtonBase,
    IconMobileId,
  },
}
</script>

<template>
  <MethodButtonBase>
    <template v-slot:slot1>
      <IconMobileId :class="$style.icon" />
    </template>
    <template v-slot:slot2>
      {{ $t('mobile-id') }}
    </template>
  </MethodButtonBase>
</template>

<style lang="scss" module>
.icon {
  display: block;
  width: 18px;
  height: auto;
  margin-right: 8px;
}
</style>
